function getQuestionFromSlug(questions, requiredSlug) {
    const res = questions.filter(({ slug }) => {
        return slug === requiredSlug
    })

    if (res.length > 0)
        return res[0]
}

function titleToSlug(title) {
    // TODO: Have to implement
    return title
}


export {
    getQuestionFromSlug,
    titleToSlug
}
